import { clsx } from 'clsx';
import { twMerge } from 'tailwind-merge';

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}

export const generateId = () => Math.random().toString(36).substr(2, 9);

export const formatCurrency = (amount) => {
  return new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
  }).format(amount);
};

export function parseLocalDate(dateString) {
  return new Date(dateString + 'T00:00:00');
}

export function formatTime12h(timeString) {
  if (!timeString) return '';
  const [h, m] = timeString.split(':');
  const hour = Number(h);
  const minute = Number(m);
  if (Number.isNaN(hour) || Number.isNaN(minute)) return '';
  const period = hour >= 12 ? 'PM' : 'AM';
  const displayHour = hour % 12 === 0 ? 12 : hour % 12;
  return `${displayHour}:${String(minute).padStart(2, '0')} ${period}`;
}

export function formatDateMMDDYYYY(dateString) {
  if (!dateString) return '';
  const [y, mo, d] = dateString.split('-');
  if (!y || !mo || !d) return '';
  return `${mo.padStart(2, '0')}/${d.padStart(2, '0')}/${y}`;
}